import { useDeleteEntityReferenceMutation } from '@crew/apis/entityReference/entityReferenceApis'
import { EntityReference } from '@crew/models/domain'
import { NotifyEventType } from 'enums/app'
import {
  ObjectEventMessage,
  notifyEntityReferencesEvent,
} from 'features/app/states/appSlice'
import { useCallback } from 'react'
import { useAppDispatch } from 'states/hooks'

export const useRelatedInfoTable = () => {
  const dispatch = useAppDispatch()

  // エンティティ参照削除API
  const [
    deleteEntityReferenceMutation,
    { isLoading: isLoadingDeleteReference },
  ] = useDeleteEntityReferenceMutation()

  // エンティティ参照を削除する
  const deleteEntityReference = useCallback(
    async (entityReferenceId: string) => {
      await deleteEntityReferenceMutation({
        entityReferenceId,
      }).unwrap()

      const objectEventMessage: ObjectEventMessage<EntityReference> = {
        eventType: NotifyEventType.Deleted,
        id: entityReferenceId,
        object: undefined,
      }
      dispatch(notifyEntityReferencesEvent(objectEventMessage))
    },
    [deleteEntityReferenceMutation, dispatch]
  )

  return {
    isLoadingDeleteReference,
    deleteEntityReference,
  }
}
